<template>
  <Modal v-model="showSessionPopup" @input="onModalInput">
    <p class="pb-2 text-lg font-bold leading-tight xl:text-2xl">
      {{ $t('popups.session.title') }}
    </p>
    <p class="pb-5 text-sm leading-tight xl:pb-8">
      {{ $t('popups.session.description') }}
    </p>
    <div class="flex">
      <a
        class="inline-flex items-center justify-center w-full py-2 text-xs font-normal cursor-pointer btn-secondary max-w-55 xl:text-base"
        href="#"
        @click.prevent="keepSessionAlive"
      >
        {{ $t('popups.session.keepAliveButton') }}
      </a>
    </div>
  </Modal>
</template>

<script>
import SessionPopup from '~app/psp/base/session-popup.ts'
import Modal from '~brand-components/lufthansa/modal/modal.vue'

export default SessionPopup.extend({
  components: {
    Modal,
  },
})
</script>
